// Angular imports
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

// Common imports
import { IconConstants, Utils } from 'cc-common';

// Component imports
import { UserBiographyComponent } from '../user-biography/user-biography.component';

// Service imports
import { UserService } from '../../_services/data-services/user.service';

// Model imports
import { UserProfileDisplayBaseDto } from '../../_models/user-profile-display-base-dto';

@Component({
    selector: 'app-user-bio-link',
    templateUrl: './user-bio-link.component.html',
    styleUrls: ['./user-bio-link.component.scss']
})
export class UserBioLinkComponent implements OnInit {
    @ViewChild('userBiography', { static: false }) userBiography: UserBiographyComponent;

    @Input() user: UserProfileDisplayBaseDto;
    @Input() communityId: number;
    @Input() showInactiveUser = false;

    @Output() onClick = new EventEmitter<void>();

    iconLock = IconConstants.LOCK;
    iconExclamatory = IconConstants.EXCLAMATORY;

    showBiography: boolean;
    canManageProfile: boolean;

    constructor(private readonly userService: UserService) {}

    ngOnInit(): void {
        const loggedInUser = this.userService.getCurrentUserInfo();
        this.canManageProfile = loggedInUser.canManageUserProfile;
    }

    get userHasProfile(): boolean {
        return (
            Utils.isTrue(this.user.hasProfile) &&
            (Utils.isTrue(this.user.approvedProfile) || Utils.isTrue(this.canManageProfile))
        );
    }

    onUserClick(): void {
        this.showBiography = true;
        setTimeout(() => {
            if (Utils.notNullAndDefined(this.userBiography)) {
                this.userBiography.show(this.user.getUserId(), this.communityId);
            }
        }, 100);
    }

    onBioClose(): void {
        this.showBiography = false;
    }
}
